export default {
  meta: {
    title: '踩点宝-踩点任务列表',
    url: '/footprinting/home', // 埋点字段，上报归属的模块
    urlName: '踩点宝' // 埋点字段，上报归属的模块
  }
};
